export class AbstractProvider {
}
